import { useCallback, useState } from 'react';

import * as api from '@/lib/api';

export enum ResetAuthState {
    PRE_AUTH = 'pre-auth',
    NOT_AUTHENTICATED = 'not-authenticated',
    AUTHENTICATED = 'authenticated',
}

export interface ResetTokeAuthData {
    authState: ResetAuthState;
    checkAuth: () => void;
    resetPassword: (password: string) => void;
}

export const useResetTokenAuth = (token?: string): ResetTokeAuthData => {
    const [authState, setAuthState] = useState(ResetAuthState.PRE_AUTH);

    const checkAuth = useCallback(async () => {
        if (token === undefined) {
            setAuthState(ResetAuthState.NOT_AUTHENTICATED);
        }
        try {
            await api.checkResetToken({ auth: token });
            setAuthState(ResetAuthState.AUTHENTICATED);
        } catch (_e) {
            setAuthState(ResetAuthState.NOT_AUTHENTICATED);
        }
    }, [token]);

    const resetPassword = useCallback(
        (password: string) => api.resetPassword({ body: { password }, auth: token }),
        [token]
    );

    return {
        authState,
        checkAuth,
        resetPassword,
    };
};
